/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Chinese (Simplified)
export default {
  'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': '清空选择',
  'paginated-picker.async-select.menu-list.error-message.error-message': '无法检索数据',
  'paginated-picker.async-select.menu-list.error-message.retry-message': '点击重试',
  'paginated-picker.async-select.menu-list.loading-message.loading-message': '正在加载...',
  'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': '显示更多',
  'paginated-picker.async-select.pagination-details.of-total-count': '{itemsCount}/{totalCount}',
  'paginated-picker.async-select.select.no-options-message.no-options-message': '未找到匹配项',
  'paginated-picker.async-select.select.option.error-message': '无法检索数据',
  'paginated-picker.async-select.select.option.retry-message': '点击重试',
  'paginated-picker.async-select.select.search-placeholder': '搜索',
  'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': '显示完整列表'
};